if (!customElements.get('swiper-component')) {
  customElements.define(
    'swiper-component',
    class SwiperComponent extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.getAttribute('data-id');
      }

      connectedCallback() {
        this.columnsDesktop = Number(this.getAttribute('data-columns-desktop'));
        this.columnsTablet = Number(this.getAttribute('data-columns-tablet'));
        this.columnsMobile = Number(this.getAttribute('data-columns-mobile'));
        this.gapDesktop = Number(this.getAttribute('data-gap-desktop'));
        this.gapTablet = Number(this.getAttribute('data-gap-tablet'));
        this.gapMobile = Number(this.getAttribute('data-gap-mobile'));

        if (!this.swiperEls.swiperContainer) return;
        this.initSwiper();
      }

      initSwiper() {
        this.swiperOptions = {
          slidesPerView: this.columnsMobile,
          spaceBetween: this.gapMobile,
          loop: true,
          navigation: this.swiperEls.prev && this.swiperEls.next ? {
            nextEl: this.swiperEls.next,
            prevEl: this.swiperEls.prev,
          } : false,
          breakpoints: {
            750: {
              slidesPerView: this.columnsTablet,
              spaceBetween: this.gapTablet,
            },
            990: {
              slidesPerView: this.columnsDesktop,
              spaceBetween: this.gapDesktop,
            }
          },
          observer: true,
          observeParents: true,
        }

        this.swiper = new Swiper(this.swiperEls.swiperContainer, this.swiperOptions);
      }

      disconnectedCallback() {
        this.swiper?.destroy();
      }

      get swiperEls() {
        return {
          swiperContainer: this.querySelector(`[id^="Swiper-${this.sectionId}"]`),
          prev: this.querySelector(`[id^="Swiper-prev-${this.sectionId}"]`),
          next: this.querySelector(`[id^="Swiper-next-${this.sectionId}"]`),
        }
      }
    }
  )
}